// Chuyển tab popup Nhiệm vụ (getlist) — dùng event delegation nên hoạt động
// kể cả khi popup được render/hiện sau.
$(function () {
	$(document).on("click", ".popup_getlist .task-tab", function (e) {
		e.preventDefault();
		var $tab = $(this);
		var key = $tab.data("tab");
		var $popup = $tab.closest(".popup_getlist");

		$popup.find(".task-tab").removeClass("active");
		$tab.addClass("active");

		$popup.find(".task-panel").removeClass("active");
		$popup.find('.task-panel[data-panel="' + key + '"]').addClass("active");
	});
});

// Scale cột cho PC (cơ chế giống 2026-thiencotraquan, nhưng nhẹ tay):
// KHÔNG nhồi cả chiều cao frame (2840px) vào viewport — thay vào đó fit theo "1 màn"
// thiết kế (DESIGN_SCREEN_H) để cột rộng vừa mắt, phần dài hơn CUỘN DỌC bình thường.
// Căn giữa ngang. Mobile để libraryMainsite tự lo (scaleWidthMB) nên thoát sớm.
window.addEventListener("load", function () {
	if ($("body").data("device-type") === "mobile") return;

	var $wrapper = $("#MS__wrapper");
	var $outer = $(".MS__outer");
	if (!$wrapper.length) return;

	var $loading = $(".MS__layer-loading");

	// Scale cố định cho PC (cột ~768×PC_SCALE ≈ 425px). Chỉnh đúng 1 số này nếu muốn cột to/nhỏ.
	var PC_SCALE = 0.55293;

	// F5 khi đang ở footer: trình duyệt tự khôi phục scroll cũ trong lúc body.height
	// được tính lại → lệch, chừa "khúc hổng". Tắt khôi phục + luôn fit từ đỉnh trang.
	if ("scrollRestoration" in history) history.scrollRestoration = "manual";

	var fitToViewport = function () {
		var baseW = $wrapper.outerWidth();
		if (!baseW) return;

		// Đo từ đỉnh trang cho nhất quán (tránh lệch khi reload giữa chừng).
		window.scrollTo(0, 0);

		var scale = Math.min(PC_SCALE, window.innerWidth / baseW);
		var offsetLeft = Math.max((window.innerWidth - baseW * scale) / 2, 0);

		// Scale + căn giữa ngang. transform KHÔNG thu layout-box nên mỗi phần tử bù
		// marginBottom âm theo chiều cao riêng để các khối xếp khít nhau.
		$("body").css("height", "");
		$wrapper.add($outer).each(function () {
			var h = this.scrollHeight || this.offsetHeight;
			$(this).css({
				transformOrigin: "left top",
				transform: "scale(" + scale + ")",
				marginLeft: offsetLeft + "px",
				marginBottom: -(h * (1 - scale)) + "px",
			});
		});

		// Cắt phần thừa: ép chiều cao body về đúng đáy nội dung THỰC sau scale
		// (đo bằng getBoundingClientRect đã tính transform) → hết "khúc dư" xanh dưới footer.
		var bottom = 0;
		$("#MS__wrapper, .MS__outer.bottom, .MS__outer.bottom .footer").each(function () {
			var r = this.getBoundingClientRect();
			bottom = Math.max(bottom, r.bottom + window.pageYOffset);
		});
		if (bottom) $("body").css({ height: Math.ceil(bottom) + "px", overflowX: "hidden" });
	};

	// Giữ loading tới khi fit xong frame đầu tiên để tránh nháy.
	$loading.css("display", "block");
	window.requestAnimationFrame(function () {
		fitToViewport();
		window.requestAnimationFrame(function () {
			$loading.css("display", "none");
		});
	});

	$(window).on("resize orientationchange", fitToViewport);
});